import React from 'react'
import { message as $message, Tooltip } from 'antd'
import copy from 'copy-to-clipboard'
import CustomIcon from '@/components/CustomIcon'

import styles from './index.less'

import { fetchPhoneNum, fetchPhoneByOp, queryPhoneByName } from '@/services/user'
import classNames from 'classnames'

export const EncryptionPhone = ({
    phone,
    showPhone = true,
    id,
    name,
    type,
    extraBefore,
    blue,
    extra,
    copyBtnText = null
}) => {
    const handleClick = async () => {
        if (!phone || phone === '-') {
            return
        }

        let phoneJson = null

        if (PROJECT_CONFIG.terminalName === PROJECT_CONFIG.adminTerminalName) {
            if (name) {
                phoneJson = await queryPhoneByName({ name })
            } else {
                phoneJson = await fetchPhoneByOp({ id, phoneTableEnum: type })
            }
        } else {
            phoneJson = await fetchPhoneNum({ id, phoneTableEnum: type })
        }

        const { success, data, message } = phoneJson

        if (success) {
            if (data) {
                let str = extra ? `手机号:${data} ${extra}` : `手机号:${data}`
                if (extraBefore) {
                    str = extraBefore + str
                }
                copy(str, {
                    format: 'text/plain',
                    onCopy: () => {
                        $message.success('复制成功')
                    }
                })
            }
        } else {
            $message.error(message)
        }
    }

    if (phone && phone !== '-') {
        return (
            <span className={styles.phoneNum} data-log-text="复制" onClick={handleClick}>
                {showPhone ? phone : ''}
                <Tooltip title="复制">
                    <CustomIcon
                        className={classNames({
                            [styles.icon]: true,
                            [styles.blue]: blue
                        })}
                        type="icon-fuzhi"
                    />
                    {copyBtnText}
                </Tooltip>
            </span>
        )
    } else {
        return null
    }
}

export default EncryptionPhone
